(function () {
        function waitFor(sel, { timeout = 10000 } = {}) {
          return new Promise((res, rej) => {
            const existing = document.querySelector(sel);
            if (existing) return res(existing);

            const mo = new MutationObserver(() => {
              const el = document.querySelector(sel);
              if (el) {
                mo.disconnect();
                res(el);
              }
            });

            mo.observe(document.documentElement, { childList: true, subtree: true });

            setTimeout(() => {
              mo.disconnect();
              rej(new Error(`Timeout: ${sel}`));
            }, timeout);
          });
        }

        function waitForAll(sel, min = 1, { timeout = 10000 } = {}) {
          return new Promise((res, rej) => {
            const get = () => Array.from(document.querySelectorAll(sel));
            const now = get();
            if (now.length >= min) return res(now);

            const mo = new MutationObserver(() => {
              const els = get();
              if (els.length >= min) {
                mo.disconnect();
                res(els);
              }
            });

            mo.observe(document.documentElement, { childList: true, subtree: true });

            setTimeout(() => {
              mo.disconnect();
              rej(new Error(`Timeout: ${sel} (min ${min})`));
            }, timeout);
          });
        }

        function hardStop(e) {
          if (!e) return;
          e.preventDefault();
          e.stopPropagation();
          if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
        }

        function ensureFocusable(el) {
          if (!el) return;
          const tabindex = el.getAttribute('tabindex');
          if (tabindex === null) el.setAttribute('tabindex', '-1');
        }

        async function initPredictiveSearch() {
          try {
            // Prefer data attribute triggers to avoid duplicate IDs across two navbars
            const triggers = await waitForAll('[data-search-toggle]', 1);

            const panel = await waitFor('.predictive-search_component');
            const closeBtn = await waitFor('.predictive-search_component .nav-close-button');
            const overlay = await waitFor('.menu-overlay');

            // Ensure panel is not hard-hidden
            panel.removeAttribute('hidden');

            // ARIA wiring
            panel.id = panel.id || 'predictive-search-dialog';

            const title = panel.querySelector('#predictive-search-title, h3, .heading-style-h2');
            if (title) title.id = title.id || 'predictive-search-title';

            triggers.forEach((btn) => {
              btn.setAttribute('aria-controls', panel.id);
              btn.setAttribute('aria-haspopup', 'dialog');
              btn.setAttribute('aria-expanded', 'false');
              if (!btn.getAttribute('aria-label')) btn.setAttribute('aria-label', 'Open search');
            });

            panel.setAttribute('role', 'dialog');
            panel.setAttribute('aria-modal', 'true');
            panel.setAttribute('aria-hidden', 'true');
            if (title) panel.setAttribute('aria-labelledby', title.id);
            ensureFocusable(panel);

            closeBtn.setAttribute('aria-label', 'Close search');

            const hasGSAP = typeof window.gsap !== 'undefined';

            // Initial placement
            if (hasGSAP) {
              panel.style.visibility = 'hidden';
              requestAnimationFrame(() => {
                panel.style.visibility = 'visible';
                window.gsap.set(panel, { xPercent: 100, autoAlpha: 0, zIndex: 9999 });
              });
            } else {
              panel.style.transform = 'translateX(100%)';
              panel.style.opacity = '0';
              panel.style.visibility = 'hidden';
              panel.style.zIndex = '9999';
            }

            // Overlay helpers
            function overlayShow() {
              overlay.classList.add('search-active');
              overlay.classList.add('active'); // aligns with common theme CSS
              overlay.style.pointerEvents = 'auto';
              overlay.setAttribute('aria-hidden', 'false');

              // If overlay is display:none by default, force it
              if (getComputedStyle(overlay).display === 'none') overlay.style.display = 'block';

              if (hasGSAP) {
                window.gsap.to(overlay, { autoAlpha: 1, duration: 0.3 });
              } else {
                overlay.style.opacity = '1';
                overlay.style.visibility = 'visible';
              }
            }

            function overlayHideIfIdle() {
              overlay.classList.remove('search-active');
              overlay.style.pointerEvents = 'none';
              overlay.setAttribute('aria-hidden', 'true');

              // Keep overlay if cart/menu still needs it
              const stillNeeded =
                overlay.classList.contains('cart-active') ||
                overlay.classList.contains('menu-active') ||
                overlay.classList.contains('active-cart') ||
                overlay.classList.contains('active-menu');

              if (stillNeeded) return;

              overlay.classList.remove('active');

              if (hasGSAP) {
                window.gsap.to(overlay, { autoAlpha: 0, duration: 0.3 });
              } else {
                overlay.style.opacity = '0';
                overlay.style.visibility = 'hidden';
              }
            }

            function openPanel(btn) {
              overlayShow();

              panel.setAttribute('aria-hidden', 'false');
              triggers.forEach((t) => t.setAttribute('aria-expanded', 'true'));

              if (hasGSAP) {
                window.gsap.to(panel, {
                  xPercent: 0,
                  autoAlpha: 1,
                  duration: 0.3,
                  ease: 'power2.out',
                  onComplete: () => {
                    panel.focus();
                    const input = panel.querySelector('input[type="search"], input[type="text"]');
                    if (input) input.focus({ preventScroll: true });
                  },
                });
              } else {
                panel.style.visibility = 'visible';
                panel.style.opacity = '1';
                panel.style.transform = 'translateX(0)';
                panel.focus();
                const input = panel.querySelector('input[type="search"], input[type="text"]');
                if (input) input.focus({ preventScroll: true });
              }
            }

            function closePanel() {
              if (panel.contains(document.activeElement)) document.activeElement.blur();

              panel.setAttribute('aria-hidden', 'true');
              triggers.forEach((t) => t.setAttribute('aria-expanded', 'false'));

              if (hasGSAP) {
                window.gsap.to(panel, {
                  xPercent: 100,
                  autoAlpha: 0,
                  duration: 0.3,
                  ease: 'power2.in',
                });
              } else {
                panel.style.opacity = '0';
                panel.style.transform = 'translateX(100%)';
                panel.style.visibility = 'hidden';
              }

              overlayHideIfIdle();
            }

            function toggleFromEvent(e) {
              hardStop(e);

              const isHidden = panel.getAttribute('aria-hidden') === 'true';
              if (isHidden) openPanel(e.currentTarget);
              else closePanel();
            }

            // Bind: capture = true to win against cart/menu handlers
            triggers.forEach((btn) => {
              btn.addEventListener('click', toggleFromEvent, { capture: true });
            });

            closeBtn.addEventListener(
              'click',
              function (e) {
                hardStop(e);
                closePanel();
              },
              { capture: true }
            );

            overlay.addEventListener('click', function () {
              if (overlay.classList.contains('search-active') && panel.getAttribute('aria-hidden') === 'false') {
                closePanel();
              }
            });

            document.addEventListener('keydown', function (e) {
              if (e.key === 'Escape' && panel.getAttribute('aria-hidden') === 'false') {
                closePanel();
              }
            });

            window.PredictiveSearch = {
              open: openPanel,
              close: closePanel,
              toggle: function () {
                const isHidden = panel.getAttribute('aria-hidden') === 'true';
                if (isHidden) openPanel(triggers[0]);
                else closePanel();
              },
            };
          } catch (err) {
            console.error('[Predictive-Search]', err.message);
          }
        }

        document.addEventListener('DOMContentLoaded', initPredictiveSearch);
      })();